var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48835 14.6739C1.22139 14.6739 1 14.4292 1 14.1341V9.81603C1 8.72212 1.8009 7.83691 2.79063 7.83691H5.83145C6.09841 7.83691 6.3198 8.0816 6.3198 8.37667V14.1341C6.3198 14.4292 6.09841 14.6739 5.83145 14.6739H1.48835ZM5.34309 13.5943V8.91643H2.79063C2.34135 8.91643 1.97671 9.31945 1.97671 9.81603V13.5943H5.34309Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13965 2.27502H5.06966",
    stroke: "currentColor",
    strokeWidth: 0.781366,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13965 3.6051H5.06966",
    stroke: "currentColor",
    strokeWidth: 0.781366,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00628 2.2749C3.69169 2.2749 4.24739 2.91188 4.24739 3.69746C4.24739 4.4834 3.69169 4.89278 3.00628 4.89278H2.13965L4.27446 6.88342",
    stroke: "currentColor",
    strokeWidth: 0.781366,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82527 14.6738C5.5583 14.6738 5.33691 14.4278 5.33691 14.1312V6.89633C5.33691 5.79663 6.13781 4.90674 7.12754 4.90674H8.86609H10.6567L10.6567 6.89633V14.1312C10.6567 14.4278 10.4418 14.6738 10.1684 14.6738H5.82527ZM9.68677 13.5886V6.89638L9.68021 5.98393L8.87285 5.99202H7.13431C6.68502 5.99202 6.32039 6.39718 6.32039 6.89638V13.5886H9.68677Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1685 14.6739C9.90156 14.6739 9.68018 14.4394 9.68018 14.1568V4.71144C9.68018 3.74049 10.4673 2.95337 11.4382 2.95337H13.2093C14.1991 2.95337 15 3.80138 15 4.84933V14.1568C15 14.4394 14.7786 14.6739 14.5116 14.6739H10.1685ZM14.0233 13.6395V4.84915C14.0233 4.37344 13.6587 3.98735 13.2094 3.98735H11.6336C11.0942 3.98735 10.6569 4.42464 10.6569 4.96406V13.6395H14.0233Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/investment.ac9620d5fa4f8d08091c8aa3d7d362c7.svg";
export { ForwardRef as ReactComponent };